import { render, staticRenderFns } from "./PageCookie.vue?vue&type=template&id=75f7a472"
import script from "./PageCookie.vue?vue&type=script&lang=js"
export * from "./PageCookie.vue?vue&type=script&lang=js"
import style0 from "./PageCookie.vue?vue&type=style&index=0&id=75f7a472&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports